import type { FunctionComponent } from "react";

import { BaseLink } from "shared/components/common/base-link";
import { config } from "shared/data";

import IconAppStore from "scmp-app/components/plus/footer/icon-app-store.svg";
import IconGooglePlay from "scmp-app/components/plus/footer/icon-google-play.svg";

import IconDevices from "./icon-devices.svg";
import IconScmpPlusLogo from "./icon-scmp-plus-logo.svg";
import {
  Container,
  ContentContainer,
  Divider,
  DownloadContainer,
  DownloadIconContainer,
  DownloadText,
  IntroText,
  SubscriptionContainer,
  SubscriptionLink,
  SubscriptionText,
} from "./styles";

export type Props = {
  className?: string;
};

export const PlusMobileScreen: FunctionComponent<Props> = ({ className }) => (
  <Container className={className}>
    <ContentContainer>
      <IconScmpPlusLogo />
      <IntroText>
        To enjoy SCMP Plus on a mobile device, you’ll need to open or download our mobile app.
      </IntroText>
      <IconDevices />
      <DownloadContainer>
        <DownloadText>Read it in the SCMP App</DownloadText>
        <DownloadIconContainer>
          <BaseLink pathname="https://scmp.onelink.me/3586748601/43f04bbb">
            <IconAppStore />
          </BaseLink>
          <BaseLink pathname="https://scmp.onelink.me/3586748601/43f04bbb">
            <IconGooglePlay />
          </BaseLink>
        </DownloadIconContainer>
      </DownloadContainer>
      <Divider />
      <SubscriptionContainer>
        <SubscriptionText>
          Please note that an{" "}
          <SubscriptionLink pathname={`${config.rosetta.subscribeHost}/plus`}>
            SCMP Plus subscription
          </SubscriptionLink>{" "}
          is required for access.
        </SubscriptionText>
      </SubscriptionContainer>
    </ContentContainer>
  </Container>
);

PlusMobileScreen.displayName = "PlusMobileScreen";
